<template>
  <div class="checkOrderLeft">
    <div class="liftDetail">
      <h6>电梯信息</h6>
      <p>
        <span>使用单位</span>
        <span>{{ detail.lift.propertyUnitName }}</span>
      </p>
      <p>
        <span>项目名称</span>
        <span>{{ detail.lift.projectName }}</span>
      </p>
      <p>
        <span>电梯位置</span>
        <span>{{ detail.lift.liftLocation }}</span>
      </p>
    </div>
    <div class="maintenanceDetail">
      <h6>保养信息</h6>
      <p>
        <span>工单编号</span>
        <span>{{ detail.orderNo }}</span>
      </p>
      <p>
        <span>维保人员</span>
        <span>{{ detail.operatorUserName }}</span>
      </p>
      <p>
        <span>保养类型</span>
        <span>{{ detail.maintainTypeName }}</span>
      </p>
      <p>
        <span>备注信息</span>
        <span>{{ detail.remark }}</span>
      </p>
      <p>
        <span>更换配件</span>
        <span>{{ detail.replacementParts }}</span>
      </p>
    </div>
    <div>
      <div class="maintenanceBox">
        <p>
          <i>状态：</i><i>{{ detail.statusName }},</i>
        </p>
        <p>
          <i>耗时：</i><i>{{ formatSeconds(detail.elapsedTime) }}</i>
        </p>
      </div>
      <div class="maintenanceBox" v-if="detail.processStatus == 0">
        <el-button class="plr28" size="mini" type="primary" @click="handlePass">审核通过</el-button>
        <el-button class="plr28" type="primary" size="mini" @click="handleNotPass">审核未通过</el-button>
      </div>
      <div class="maintenanceBox" v-if="detail.processStatus != 0">
        <p>
          <i>审核状态：</i><i>{{ processStatusName }}</i>
        </p>
      </div>
      <el-table :data="detail.logList" style="width: 100%" max-height="200px">
        <el-table-column prop="statusName" label="状态" width="70">
        </el-table-column>
        <el-table-column prop="createTime" label="时间" width="150">
        </el-table-column>
        <el-table-column prop="address" label="操作位置" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="distance" width="100" label="与目标距离" show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import {
    processStatus
  } from "@/api/MaintenanceWorkOrder";
  export default {
    data() {
      return {
        processStatusName: ""
      }
    },
    props: {
      detail: {
        type: Object,
        default: () => {
          return {
            lift: {},
          };
        },
      },
    },
    created() {
      this.processStatusName = this.detail.processStatusName;
    },
    methods: {
      handlePass() {
        const maintainOrderId = this.detail.orderId

        this.$confirm("确定审核通过?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          const res = await processStatus({
            maintainOrderId: maintainOrderId,
            processStatus: 1
          });
          if (res.code === 200) {
            this.detail.processStatus = 1
            this.processStatusName = '通过'
            console.log(this.processStatusName)
            this.$message.success("操作成功");
            this.$emit("cancel");
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      handleNotPass() {
        const orderIdList = [row.orderId];
        this.$confirm("确定推送确定审核未通过?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          const res = await orderPush({
            maintainOrderId: maintainOrderId,
            processStatus: 2
          });
          if (res.code === 200) {
            this.detail.processStatus = 2
            this.processStatusName = '未通过'
            this.$message.success("操作成功");
            this.$emit("cancel");
            done();
          }
        }).catch((err) => {
          console.log(err);
        });

      },

      formatSeconds(value) {
        if (!value) {
          return ''
        }
        var theTime = parseInt(value); // 秒
        var middle = 0; // 分
        var hour = 0; // 小时

        if (theTime > 60) {
          middle = parseInt(theTime / 60);
          theTime = parseInt(theTime % 60);
          if (middle > 60) {
            hour = parseInt(middle / 60);
            middle = parseInt(middle % 60);
          }
        }
        var result = "" + parseInt(theTime) + "秒";
        if (middle > 0) {
          result = "" + parseInt(middle) + "分" + result;
        }
        if (hour > 0) {
          result = "" + parseInt(hour) + "小时" + result;
        }
        return result;
      },
    },
  };
</script>

<style lang="scss">
  .checkOrderLeft {
    .liftDetail {
      font-size: 14px;

      p:last-child {
        margin-bottom: 23px;
      }
    }

    p {
      display: flex;
      margin-bottom: 16px;

      span:first-child {
        margin-right: 20px;
      }

      span:last-child {
        color: #999999;
      }
    }

    h6 {
      color: #333333;
      position: relative;
      font-size: 14px;
      margin-bottom: 23px;

      &::before {
        position: absolute;
        content: " ";
        width: 4px;
        height: 14px;
        background: #0092ff;
        top: 2px;
        left: -8px;
      }
    }

    .maintenanceBox {
      display: flex;

      i {
        font-style: normal;
      }

      p {
        margin-right: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/MaintenanceWorkOrder/components/CheckOrderLeft.vue